import { SoccerEventStatusId } from '@collector/sportsapi-client-legacy'

import { PitchBlockedEventStatus } from '../../configuration'

export const pitchBlockedEventStatus: PitchBlockedEventStatus<SoccerEventStatusId> =
  new Set([
    SoccerEventStatusId.NotStarted,
    SoccerEventStatusId.StartDelayed,
    SoccerEventStatusId.Postponed,
    SoccerEventStatusId.Halftime,
    SoccerEventStatusId.WaitingForExtratime,
    SoccerEventStatusId.ExtratimeHalftime,
    SoccerEventStatusId.WaitingForPenalty,
    SoccerEventStatusId.PenaltyShootout,
    SoccerEventStatusId.FinishedRegularTime,
    SoccerEventStatusId.FinishedAfterExtratime,
    SoccerEventStatusId.FinishedAfterPenalties,
    SoccerEventStatusId.FinishedAwardedWin,
    SoccerEventStatusId.Interrupted,
    SoccerEventStatusId.Abandoned,
    SoccerEventStatusId.Cancelled,
    SoccerEventStatusId.ToFinish,
  ])
